import type { ComponentType, ImgHTMLAttributes, SVGProps } from "react";

/* --- Icons (gekürzt) ----------------------------------------- */
import {
  GlobalToolsLogo,
  TimeTracQLogo,
  RoadmapLogo,
  HealthLogo,
  OuraLogo,
  PersonalDevelopmentLogo,
  MiracleFlowLogo,
  ChatGPTLogo,
  LLMLogo,
  SettingsLogo,
} from "@/components/icons/aspects";
import {
  AdminPanelLogo,
  NexusLogo,
  InvestmentsLogo,
  TradingLogo,
  ResponsumOSLogo,
  RealEstateLogo,
  OthersLogo,
  SmartHomeLogo,
} from "@/components/icons/workspaces";

/* ---------- Typ ------------------------------------------------ */
export interface NavNode {
  children?: NavNode[];
  icon?:
    | ComponentType<ImgHTMLAttributes<HTMLImageElement>>
    | ComponentType<SVGProps<SVGSVGElement>>;
  id: string;
  link?: string; // muss im Router existieren
  title: string;
}

/* ============================================================== */
/*                         NAVIGATION TREE                        */
/* ============================================================== */
export const navTree: NavNode = {
  children: [
    /* ===== Admin Panel ======================================== */
    {
      children: [
        {
          icon: GlobalToolsLogo,
          id: "notifications",
          link: "/admin/notifications",
          title: "Notifications",
        },
        {
          icon: RoadmapLogo,
          id: "roadmap",
          link: "/roadmap",
          title: "Roadmap",
        },
        {
          icon: RoadmapLogo,
          id: "scripts",
          link: "/scripts",
          title: "Scripts",
        },
        {
          icon: TimeTracQLogo,
          id: "timetracq",
          link: "/timetracq",
          title: "TimeTracQ",
        },
      ],
      icon: AdminPanelLogo,
      id: "admin-panel",
      link: "/admin",
      title: "Admin Panel",
    },

    /* ===== Nexus ============================================== */
    {
      children: [
        /* -- Health (Outlet) ----------------------------------- */
        {
          children: [
            {
              icon: OuraLogo,
              id: "oura",
              link: "/nexus/health/oura",
              title: "Oura",
            },
            {
              icon: HealthLogo,
              id: "withings",
              link: "/nexus/health/withings",
              title: "Withings",
            },
          ],
          icon: HealthLogo,
          id: "health",
          link: "/nexus/health", // NEU – Outlet-Route
          title: "Health",
        },

        /* -- Personal Development (Outlet) --------------------- */
        {
          children: [
            {
              icon: MiracleFlowLogo,
              id: "miracle-flow",
              link: "/miracle-flow",
              title: "MiracleFlow",
            },
          ],
          icon: PersonalDevelopmentLogo,
          id: "personal-development",
          link: "/nexus/personal-development", // NEU – Outlet-Route
          title: "Personal Development",
        },
      ],
      icon: NexusLogo,
      id: "nexus",
      link: "/nexus",
      title: "Nexus",
    },

    /* ===== Weitere Workspaces ================================= */
    {
      icon: InvestmentsLogo,
      id: "investments",
      link: "/investments",
      title: "Investments",
    },
    { icon: TradingLogo, id: "trading", link: "/trading", title: "Trading" },
    {
      icon: ResponsumOSLogo,
      id: "responsumos",
      link: "/responsumos",
      title: "ResponsumOS",
    },
    {
      icon: RealEstateLogo,
      id: "real-estate",
      link: "/real-estate",
      title: "Real Estate",
    },
    {
      icon: SmartHomeLogo,
      id: "smarthome",
      link: "/smarthome",
      title: "Smart Home",
    },

    /* ===== LLM Services ======================================= */
    {
      children: [
        {
          icon: ChatGPTLogo,
          id: "chatgpt",
          link: "/llm/chatgpt",
          title: "ChatGPT",
        },
        { icon: LLMLogo, id: "ollama", link: "/llm/ollama", title: "Ollama" },
      ],
      icon: LLMLogo,
      id: "llm-services",
      link: "/llm",
      title: "LLM Services",
    },

    /* ===== Others ============================================= */
    {
      children: [
        {
          icon: SettingsLogo,
          id: "settings",
          link: "/settings",
          title: "Settings",
        },
      ],
      icon: OthersLogo,
      id: "others",
      link: "/others",
      title: "Others",
    },
  ],
  id: "root",
  title: "root",
};

/* ============================================================== */
/*                     FAST-LOOKUP MAPS                           */
/* ============================================================== */
export const nodeMap = new Map<string, NavNode>();
export const parentMap = new Map<string, string>();
export const linkMap = new Map<string, NavNode>();

(function buildMaps(node: NavNode, parentId?: string) {
  nodeMap.set(node.id, node);
  if (parentId) {
    parentMap.set(node.id, parentId);
  }
  if (node.link) {
    linkMap.set(node.link, node);
  }
  if (node.children) {
    for (const child of node.children) {
      buildMaps(child, node.id);
    }
  }
})(navTree);
